import axios from "axios";
import store from "..";

export async function login() {
    return 'do something'
}


export async function checkAuth() {
    try {
        const isAuth = await axios.get(store.state.apiUrl + '/auth', {withCredentials: true})
        if (isAuth.data.user) store.state.currentUser = isAuth.data.user
        
        return isAuth
    } catch(err) {
        console.log(err);
        return false
    }
}